import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: false,
  errorMessage: "",
  errorMessageData: "",
  items: [],
};

export const claimedHistorySlice = createSlice({
  name: "claimedHistory",
  initialState,
  reducers: {
    claimedHistoryInprogress: () => {
      return {
        ...initialState,
        loading: true,
      };
    },

    claimedHistoryProcessed: (state, { payload }) => {
      return {
        ...initialState,
        ...payload,
      };
    },

    claimedHistoryCompleted: () => {
      return initialState;
    },
  },
});

export const {
  claimedHistoryInprogress,
  claimedHistoryProcessed,
  claimedHistoryCompleted,
} = claimedHistorySlice.actions;

export default claimedHistorySlice.reducer;
